import BaseModelAPI from '../BaseModelAPI';

export default class DiSubcontDeliveryCardList extends BaseModelAPI {

	static entity = 'newobject1912list'
	static entityName = 'disubcontdeliverycard';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
